module.exports = "/out/44197f667cc90647ea628596c679940f.svg";